<div class="brook-call-to-action bg_color--2 ptb--70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-sm-6 col-12">
                <div class="call-content text-center text-sm-left">
                    <h3 class="heading heading-h3 text-white wow move-up">¿TE GUSTARÍA DESCARGAR LA FORMACIÓN COMPLETA?</h3>
                </div>
            </div>
            <div class="col-lg-6 col-sm-6 col-12">
                <div class="call-btn text-center text-sm-right mt_mobile--20 wow move-up">
                    <a class="brook-btn bk-btn-white text-theme btn-sd-size btn-rounded" href="" target="_blank">DESCÁRGALA AQUÍ</a>
                </div>
            </div>
        </div>
    </div>
</div>

